import { RcClasses } from '../../../../foundation';
export var RcCardHoverActionsClasses = RcClasses(['root', 'visible'], 'RcCardHoverActions');
